import { render, staticRenderFns } from "./v-searchable-select-address.vue?vue&type=template&id=204525a5&scoped=true&"
import script from "./v-searchable-select-address.vue?vue&type=script&lang=js&"
export * from "./v-searchable-select-address.vue?vue&type=script&lang=js&"
import style0 from "./v-searchable-select-address.vue?vue&type=style&index=0&id=204525a5&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "204525a5",
  null
  
)

export default component.exports